import React from 'react';
export default function DataContent() {
  return (
    <>

      {/* How Work Section Start */}
      <section className="process_v2 section_padding">
        <div className="container">

          <div className="row">
            <div className="col-lg-12">
              <div className="services-header text-center mb-5">
                <span className="services-badge">How It Works</span>
                <h2 className="services-title">Easy Steps to Get Started</h2>
              </div>
            </div>
          </div>

          <div className="process_wrapper">
            <div className="process_item">
              <div className="process_icon">
                <i className="fa fa-hand-o-up"></i>
              </div>
              <span>Step 1</span>
              <h5>Select the Service</h5>
            </div>

            <div className="process_arrow">
              <i className="fa fa-long-arrow-right"></i>
            </div>

            <div className="process_item">
              <div className="process_icon">
                <i className="fa fa-share-square-o"></i>
              </div>
              <span>Step 2</span>
              <h5>Send Inquiry</h5>
            </div>

            <div className="process_arrow">
              <i className="fa fa-long-arrow-right"></i>
            </div>

            <div className="process_item">
              <div className="process_icon">
                <i className="fa fa-question"></i>
              </div>
              <span>Step 3</span>
              <h5>Ask Question</h5>
            </div>

            <div className="process_arrow">
              <i className="fa fa-long-arrow-right"></i>
            </div>

            <div className="process_item">
              <div className="process_icon">
                <i className="fa fa-file-text-o"></i>
              </div>
              <span>Step 4</span>
              <h5>Send Document</h5>
            </div>

            <div className="process_arrow">
              <i className="fa fa-long-arrow-right"></i>
            </div>

            <div className="process_item">
              <div className="process_icon">
                <i className="fa fa-money"></i>
              </div>
              <span>Step 5</span>
              <h5>Pay Online</h5>
            </div>

            <div className="process_arrow">
              <i className="fa fa-long-arrow-right"></i>
            </div>

            <div className="process_item">
              <div className="process_icon">
                <i className="fa fa-hourglass-start"></i>
              </div>
              <span>Step 6</span>
              <h5>Work Start</h5>
            </div>

          </div>

        </div>
      </section>
      {/* How Work Section End */}


    </>
  );
}
